export const countryCodes = [
  {
    "country": "AF",
    "name": "Afghanistan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AX",
    "name": "Aland Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AL",
    "name": "Albania",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DZ",
    "name": "Algeria",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AS",
    "name": "American Samoa",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AD",
    "name": "Andorra",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AO",
    "name": "Angola",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AI",
    "name": "Anguilla",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AQ",
    "name": "Antarctica",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AG",
    "name": "Antigua and Barbuda",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AR",
    "name": "Argentina",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "B",
        "name": "Buenos Aires"
      },
      {
        "state": "K",
        "name": "Catamarca"
      },
      {
        "state": "H",
        "name": "Chaco"
      },
      {
        "state": "U",
        "name": "Chubut"
      },
      {
        "state": "C",
        "name": "Ciudad Autónoma de Buenos Aires"
      },
      {
        "state": "X",
        "name": "Córdoba"
      },
      {
        "state": "W",
        "name": "Corrientes"
      },
      {
        "state": "E",
        "name": "Entre Ríos"
      },
      {
        "state": "P",
        "name": "Formosa"
      },
      {
        "state": "Y",
        "name": "Jujuy"
      },
      {
        "state": "L",
        "name": "La Pampa"
      },
      {
        "state": "F",
        "name": "La Rioja"
      },
      {
        "state": "M",
        "name": "Mendoza"
      },
      {
        "state": "N",
        "name": "Misiones"
      },
      {
        "state": "Q",
        "name": "Neuquén"
      },
      {
        "state": "R",
        "name": "Río Negro"
      },
      {
        "state": "A",
        "name": "Salta"
      },
      {
        "state": "J",
        "name": "San Juan"
      },
      {
        "state": "D",
        "name": "San Luis"
      },
      {
        "state": "Z",
        "name": "Santa Cruz"
      },
      {
        "state": "S",
        "name": "Santa Fe"
      },
      {
        "state": "G",
        "name": "Santiago del Estero"
      },
      {
        "state": "V",
        "name": "Tierra del Fuego"
      },
      {
        "state": "T",
        "name": "Tucumán"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AM",
    "name": "Armenia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AW",
    "name": "Aruba",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AU",
    "name": "Australia",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "ACT",
        "name": "Australian Capital Territory"
      },
      {
        "state": "NSW",
        "name": "New South Wales"
      },
      {
        "state": "NT",
        "name": "Northern Territory"
      },
      {
        "state": "QLD",
        "name": "Queensland"
      },
      {
        "state": "SA",
        "name": "South Australia"
      },
      {
        "state": "TAS",
        "name": "Tasmania"
      },
      {
        "state": "VIC",
        "name": "Victoria"
      },
      {
        "state": "WA",
        "name": "Western Australia"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AT",
    "name": "Austria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AZ",
    "name": "Azerbaijan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BS",
    "name": "Bahamas",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BH",
    "name": "Bahrain",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BD",
    "name": "Bangladesh",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BB",
    "name": "Barbados",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BY",
    "name": "Belarus",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BE",
    "name": "Belgium",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BZ",
    "name": "Belize",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BJ",
    "name": "Benin",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BM",
    "name": "Bermuda",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BT",
    "name": "Bhutan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BO",
    "name": "Bolivia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BQ",
    "name": "Bonaire, Saint Eustatius and Saba",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BA",
    "name": "Bosnia and Herzegovina",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BW",
    "name": "Botswana",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BV",
    "name": "Bouvet Island",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BR",
    "name": "Brazil",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AC",
        "name": "Acre"
      },
      {
        "state": "AL",
        "name": "Alagoas"
      },
      {
        "state": "AP",
        "name": "Amapá"
      },
      {
        "state": "AM",
        "name": "Amazonas"
      },
      {
        "state": "BA",
        "name": "Bahia"
      },
      {
        "state": "CE",
        "name": "Ceará"
      },
      {
        "state": "DF",
        "name": "Distrito Federal"
      },
      {
        "state": "ES",
        "name": "Espírito Santo"
      },
      {
        "state": "GO",
        "name": "Goiás"
      },
      {
        "state": "MA",
        "name": "Maranhão"
      },
      {
        "state": "MT",
        "name": "Mato Grosso"
      },
      {
        "state": "MS",
        "name": "Mato Grosso do Sul"
      },
      {
        "state": "MG",
        "name": "Minas Gerais"
      },
      {
        "state": "PA",
        "name": "Pará"
      },
      {
        "state": "PB",
        "name": "Paraíba"
      },
      {
        "state": "PR",
        "name": "Paraná"
      },
      {
        "state": "PE",
        "name": "Pernambuco"
      },
      {
        "state": "PI",
        "name": "Piauí"
      },
      {
        "state": "RJ",
        "name": "Rio de Janeiro"
      },
      {
        "state": "RN",
        "name": "Rio Grande do Norte"
      },
      {
        "state": "RS",
        "name": "Rio Grande do Sul"
      },
      {
        "state": "RO",
        "name": "Rondônia"
      },
      {
        "state": "RR",
        "name": "Roraima"
      },
      {
        "state": "SC",
        "name": "Santa Catarina"
      },
      {
        "state": "SP",
        "name": "São Paulo"
      },
      {
        "state": "SE",
        "name": "Sergipe"
      },
      {
        "state": "TO",
        "name": "Tocantins"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IO",
    "name": "British Indian Ocean Territory",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BN",
    "name": "Brunei Darussalam",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BG",
    "name": "Bulgaria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BF",
    "name": "Burkina Faso",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "BI",
    "name": "Burundi",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KH",
    "name": "Cambodia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CM",
    "name": "Cameroon",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CA",
    "name": "Canada",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AB",
        "name": "Alberta"
      },
      {
        "state": "BC",
        "name": "British Columbia"
      },
      {
        "state": "MB",
        "name": "Manitoba"
      },
      {
        "state": "NB",
        "name": "New Brunswick"
      },
      {
        "state": "NL",
        "name": "Newfoundland and Labrador"
      },
      {
        "state": "NT",
        "name": "Northwest Territories"
      },
      {
        "state": "NS",
        "name": "Nova Scotia"
      },
      {
        "state": "NU",
        "name": "Nunavut"
      },
      {
        "state": "ON",
        "name": "Ontario"
      },
      {
        "state": "PE",
        "name": "Prince Edward Island"
      },
      {
        "state": "QC",
        "name": "Quebec"
      },
      {
        "state": "SK",
        "name": "Saskatchewan"
      },
      {
        "state": "YT",
        "name": "Yukon"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IC",
    "name": "Canary Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CV",
    "name": "Cape Verde",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KY",
    "name": "Cayman Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CF",
    "name": "Central African Republic",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TD",
    "name": "Chad",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CL",
    "name": "Chile",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CN",
    "name": "China",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AH",
        "name": "Anhui Sheng"
      },
      {
        "state": "BJ",
        "name": "Beijing Shi"
      },
      {
        "state": "CQ",
        "name": "Chongqing Shi"
      },
      {
        "state": "FJ",
        "name": "Fujian Sheng"
      },
      {
        "state": "GS",
        "name": "Gansu Sheng"
      },
      {
        "state": "GD",
        "name": "Guangdong Sheng"
      },
      {
        "state": "GX",
        "name": "Guangxi Zhuangzu Zizhiqu"
      },
      {
        "state": "GZ",
        "name": "Guizhou Sheng"
      },
      {
        "state": "HI",
        "name": "Hainan Sheng"
      },
      {
        "state": "HE",
        "name": "Hebei Sheng"
      },
      {
        "state": "HL",
        "name": "Heilongjiang Sheng"
      },
      {
        "state": "HA",
        "name": "Henan Sheng"
      },
      {
        "state": "HK",
        "name": "Hong Kong SAR"
      },
      {
        "state": "HB",
        "name": "Hubei Sheng"
      },
      {
        "state": "HN",
        "name": "Hunan Sheng"
      },
      {
        "state": "JS",
        "name": "Jiangsu Sheng"
      },
      {
        "state": "JX",
        "name": "Jiangxi Sheng"
      },
      {
        "state": "JL",
        "name": "Jilin Sheng"
      },
      {
        "state": "LN",
        "name": "Liaoning Sheng"
      },
      {
        "state": "MO",
        "name": "Macau SAR"
      },
      {
        "state": "NM",
        "name": "Nei Mongol Zizhiqu"
      },
      {
        "state": "NX",
        "name": "Ningxia Huizu Zizhiqu"
      },
      {
        "state": "QH",
        "name": "Qinghai Sheng"
      },
      {
        "state": "SN",
        "name": "Shaanxi Sheng"
      },
      {
        "state": "SD",
        "name": "Shandong Sheng"
      },
      {
        "state": "SH",
        "name": "Shanghai Shi"
      },
      {
        "state": "SX",
        "name": "Shanxi Sheng"
      },
      {
        "state": "SC",
        "name": "Sichuan Sheng"
      },
      {
        "state": "TW",
        "name": "Taiwan Sheng"
      },
      {
        "state": "TJ",
        "name": "Tianjin Shi"
      },
      {
        "state": "XJ",
        "name": "Xinjiang Uygur Zizhiqu"
      },
      {
        "state": "XZ",
        "name": "Xizang Zizhiqu"
      },
      {
        "state": "YN",
        "name": "Yunnan Sheng"
      },
      {
        "state": "ZJ",
        "name": "Zhejiang Sheng"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CO",
    "name": "Colombia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KM",
    "name": "Comoros",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CG",
    "name": "Congo",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CD",
    "name": "Congo, The Democratic Republic of the",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CK",
    "name": "Cook Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CR",
    "name": "Costa Rica",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CI",
    "name": "Cote D'Ivoire",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "HR",
    "name": "Croatia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CU",
    "name": "Cuba",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CW",
    "name": "Curaçao",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CY",
    "name": "Cyprus",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "CZ",
    "name": "Czech Republic",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DK",
    "name": "Denmark",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DJ",
    "name": "Djibouti",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DM",
    "name": "Dominica",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DO",
    "name": "Dominican Republic",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "02",
        "name": "Azua"
      },
      {
        "state": "03",
        "name": "Baoruco"
      },
      {
        "state": "04",
        "name": "Barahona"
      },
      {
        "state": "05",
        "name": "Dajabón"
      },
      {
        "state": "01",
        "name": "Distrito Nacional"
      },
      {
        "state": "06",
        "name": "Duarte"
      },
      {
        "state": "08",
        "name": "El Seibo"
      },
      {
        "state": "07",
        "name": "Elías Piña"
      },
      {
        "state": "09",
        "name": "Espaillat"
      },
      {
        "state": "30",
        "name": "Hato Mayor"
      },
      {
        "state": "19",
        "name": "Hermanas Mirabal"
      },
      {
        "state": "10",
        "name": "Independencia"
      },
      {
        "state": "11",
        "name": "La Altagracia"
      },
      {
        "state": "12",
        "name": "La Romana"
      },
      {
        "state": "13",
        "name": "La Vega"
      },
      {
        "state": "14",
        "name": "María Trinidad Sánchez"
      },
      {
        "state": "28",
        "name": "Monseñor Nouel"
      },
      {
        "state": "15",
        "name": "Monte Cristi"
      },
      {
        "state": "29",
        "name": "Monte Plata"
      },
      {
        "state": "16",
        "name": "Pedernales"
      },
      {
        "state": "17",
        "name": "Peravia"
      },
      {
        "state": "18",
        "name": "Puerto Plata"
      },
      {
        "state": "20",
        "name": "Samaná"
      },
      {
        "state": "21",
        "name": "San Cristóbal"
      },
      {
        "state": "31",
        "name": "San José de Ocoa"
      },
      {
        "state": "22",
        "name": "San Juan"
      },
      {
        "state": "23",
        "name": "San Pedro de Macorís"
      },
      {
        "state": "24",
        "name": "Sánchez Ramírez"
      },
      {
        "state": "25",
        "name": "Santiago"
      },
      {
        "state": "26",
        "name": "Santiago Rodríguez"
      },
      {
        "state": "32",
        "name": "Santo Domingo"
      },
      {
        "state": "27",
        "name": "Valverde"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "EC",
    "name": "Ecuador",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "EG",
    "name": "Egypt",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SV",
    "name": "El Salvador",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GQ",
    "name": "Equatorial Guinea",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ER",
    "name": "Eritrea",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "EE",
    "name": "Estonia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SZ",
    "name": "Eswatini",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ET",
    "name": "Ethiopia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FK",
    "name": "Falkland Islands (Malvinas)",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FO",
    "name": "Faroe Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FJ",
    "name": "Fiji",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FI",
    "name": "Finland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FR",
    "name": "France",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GF",
    "name": "French Guiana",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PF",
    "name": "French Polynesia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GA",
    "name": "Gabon",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GM",
    "name": "Gambia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GE",
    "name": "Georgia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "DE",
    "name": "Germany",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GH",
    "name": "Ghana",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GI",
    "name": "Gibraltar",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GR",
    "name": "Greece",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GL",
    "name": "Greenland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GD",
    "name": "Grenada",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GP",
    "name": "Guadeloupe",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GU",
    "name": "Guam",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GT",
    "name": "Guatemala",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GG",
    "name": "Guernsey",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GN",
    "name": "Guinea",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GW",
    "name": "Guinea-Bissau",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GY",
    "name": "Guyana",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "HT",
    "name": "Haiti",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VA",
    "name": "Holy See (Vatican City State)",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "HN",
    "name": "Honduras",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "HK",
    "name": "Hong Kong",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "HU",
    "name": "Hungary",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IS",
    "name": "Iceland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IN",
    "name": "India",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AN",
        "name": "Andaman and Nicobar Islands"
      },
      {
        "state": "AP",
        "name": "Andhra Pradesh"
      },
      {
        "state": "AR",
        "name": "Arunachal Pradesh"
      },
      {
        "state": "AS",
        "name": "Assam"
      },
      {
        "state": "BR",
        "name": "Bihar"
      },
      {
        "state": "CH",
        "name": "Chandigarh"
      },
      {
        "state": "CT",
        "name": "Chhattisgarh"
      },
      {
        "state": "DN",
        "name": "Dadra and Nagar Haveli"
      },
      {
        "state": "DD",
        "name": "Daman and Diu"
      },
      {
        "state": "DL",
        "name": "Delhi"
      },
      {
        "state": "GA",
        "name": "Goa"
      },
      {
        "state": "GJ",
        "name": "Gujarat"
      },
      {
        "state": "HR",
        "name": "Haryana"
      },
      {
        "state": "HP",
        "name": "Himachal Pradesh"
      },
      {
        "state": "JK",
        "name": "Jammu and Kashmir"
      },
      {
        "state": "JH",
        "name": "Jharkhand"
      },
      {
        "state": "KA",
        "name": "Karnataka"
      },
      {
        "state": "KL",
        "name": "Kerala"
      },
      {
        "state": "LA",
        "name": "Ladakh"
      },
      {
        "state": "LD",
        "name": "Lakshadweep"
      },
      {
        "state": "MP",
        "name": "Madhya Pradesh"
      },
      {
        "state": "MH",
        "name": "Maharashtra"
      },
      {
        "state": "MN",
        "name": "Manipur"
      },
      {
        "state": "ML",
        "name": "Meghalaya"
      },
      {
        "state": "MZ",
        "name": "Mizoram"
      },
      {
        "state": "NL",
        "name": "Nagaland"
      },
      {
        "state": "OR",
        "name": "Odisha"
      },
      {
        "state": "PY",
        "name": "Puducherry"
      },
      {
        "state": "PB",
        "name": "Punjab"
      },
      {
        "state": "RJ",
        "name": "Rajasthan"
      },
      {
        "state": "SK",
        "name": "Sikkim"
      },
      {
        "state": "TN",
        "name": "Tamil Nadu"
      },
      {
        "state": "TG",
        "name": "Telangana"
      },
      {
        "state": "TR",
        "name": "Tripura"
      },
      {
        "state": "UP",
        "name": "Uttar Pradesh"
      },
      {
        "state": "UT",
        "name": "Uttarakhand"
      },
      {
        "state": "WB",
        "name": "West Bengal"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ID",
    "name": "Indonesia",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "BA",
        "name": "Bali"
      },
      {
        "state": "BB",
        "name": "Bangka Belitung"
      },
      {
        "state": "BT",
        "name": "Banten"
      },
      {
        "state": "BE",
        "name": "Bengkulu"
      },
      {
        "state": "YO",
        "name": "DI Yogyakarta"
      },
      {
        "state": "JK",
        "name": "DKI Jakarta"
      },
      {
        "state": "GO",
        "name": "Gorontalo"
      },
      {
        "state": "JA",
        "name": "Jambi"
      },
      {
        "state": "JB",
        "name": "Jawa Barat"
      },
      {
        "state": "JT",
        "name": "Jawa Tengah"
      },
      {
        "state": "JI",
        "name": "Jawa Timur"
      },
      {
        "state": "KB",
        "name": "Kalimantan Barat"
      },
      {
        "state": "KS",
        "name": "Kalimantan Selatan"
      },
      {
        "state": "KT",
        "name": "Kalimantan Tengah"
      },
      {
        "state": "KI",
        "name": "Kalimantan Timur"
      },
      {
        "state": "KU",
        "name": "Kalimantan Utara"
      },
      {
        "state": "KR",
        "name": "Kepulauan Riau"
      },
      {
        "state": "LA",
        "name": "Lampung"
      },
      {
        "state": "MA",
        "name": "Maluku"
      },
      {
        "state": "MU",
        "name": "Maluku Utara"
      },
      {
        "state": "AC",
        "name": "Nanggroe Aceh Darussalam"
      },
      {
        "state": "NB",
        "name": "Nusa Tenggara Barat"
      },
      {
        "state": "NT",
        "name": "Nusa Tenggara Timur"
      },
      {
        "state": "PA",
        "name": "Papua"
      },
      {
        "state": "PB",
        "name": "Papua Barat"
      },
      {
        "state": "RI",
        "name": "Riau"
      },
      {
        "state": "SR",
        "name": "Sulawesi Barat"
      },
      {
        "state": "SN",
        "name": "Sulawesi Selatan"
      },
      {
        "state": "ST",
        "name": "Sulawesi Tengah"
      },
      {
        "state": "SG",
        "name": "Sulawesi Tenggara"
      },
      {
        "state": "SA",
        "name": "Sulawesi Utara"
      },
      {
        "state": "SB",
        "name": "Sumatera Barat"
      },
      {
        "state": "SS",
        "name": "Sumatera Selatan"
      },
      {
        "state": "SU",
        "name": "Sumatera Utara"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IR",
    "name": "Iran, Islamic Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IQ",
    "name": "Iraq",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IE",
    "name": "Ireland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IM",
    "name": "Isle of Man",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IL",
    "name": "Israel",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "IT",
    "name": "Italy",
    "eu": true,
    "language": "en",
    "states": [
      {
        "state": "AG",
        "name": "Agrigento"
      },
      {
        "state": "AL",
        "name": "Alessandria"
      },
      {
        "state": "AN",
        "name": "Ancona"
      },
      {
        "state": "AO",
        "name": "Aosta"
      },
      {
        "state": "AR",
        "name": "Arezzo"
      },
      {
        "state": "AP",
        "name": "Ascoli Piceno"
      },
      {
        "state": "AT",
        "name": "Asti"
      },
      {
        "state": "AV",
        "name": "Avellino"
      },
      {
        "state": "BA",
        "name": "Bari"
      },
      {
        "state": "BT",
        "name": "Barletta-Andria-Trani"
      },
      {
        "state": "BL",
        "name": "Belluno"
      },
      {
        "state": "BN",
        "name": "Benevento"
      },
      {
        "state": "BG",
        "name": "Bergamo"
      },
      {
        "state": "BI",
        "name": "Biella"
      },
      {
        "state": "BO",
        "name": "Bologna"
      },
      {
        "state": "BZ",
        "name": "Bolzano"
      },
      {
        "state": "BS",
        "name": "Brescia"
      },
      {
        "state": "BR",
        "name": "Brindisi"
      },
      {
        "state": "CA",
        "name": "Cagliari"
      },
      {
        "state": "CL",
        "name": "Caltanissetta"
      },
      {
        "state": "CB",
        "name": "Campobasso"
      },
      {
        "state": "CI",
        "name": "Carbonia-Iglesias"
      },
      {
        "state": "CE",
        "name": "Caserta"
      },
      {
        "state": "CT",
        "name": "Catania"
      },
      {
        "state": "CZ",
        "name": "Catanzaro"
      },
      {
        "state": "CH",
        "name": "Chieti"
      },
      {
        "state": "CO",
        "name": "Como"
      },
      {
        "state": "CS",
        "name": "Cosenza"
      },
      {
        "state": "CR",
        "name": "Cremona"
      },
      {
        "state": "KR",
        "name": "Crotone"
      },
      {
        "state": "CN",
        "name": "Cuneo"
      },
      {
        "state": "EN",
        "name": "Enna"
      },
      {
        "state": "FM",
        "name": "Fermo"
      },
      {
        "state": "FE",
        "name": "Ferrara"
      },
      {
        "state": "FI",
        "name": "Firenze"
      },
      {
        "state": "FG",
        "name": "Foggia"
      },
      {
        "state": "FC",
        "name": "Forlì-Cesena"
      },
      {
        "state": "FR",
        "name": "Frosinone"
      },
      {
        "state": "GE",
        "name": "Genova"
      },
      {
        "state": "GO",
        "name": "Gorizia"
      },
      {
        "state": "GR",
        "name": "Grosseto"
      },
      {
        "state": "IM",
        "name": "Imperia"
      },
      {
        "state": "IS",
        "name": "Isernia"
      },
      {
        "state": "AQ",
        "name": "L'Aquila"
      },
      {
        "state": "SP",
        "name": "La Spezia"
      },
      {
        "state": "LT",
        "name": "Latina"
      },
      {
        "state": "LE",
        "name": "Lecce"
      },
      {
        "state": "LC",
        "name": "Lecco"
      },
      {
        "state": "LI",
        "name": "Livorno"
      },
      {
        "state": "LO",
        "name": "Lodi"
      },
      {
        "state": "LU",
        "name": "Lucca"
      },
      {
        "state": "MC",
        "name": "Macerata"
      },
      {
        "state": "MN",
        "name": "Mantova"
      },
      {
        "state": "MS",
        "name": "Massa-Carrara"
      },
      {
        "state": "MT",
        "name": "Matera"
      },
      {
        "state": "VS",
        "name": "Medio Campidano"
      },
      {
        "state": "ME",
        "name": "Messina"
      },
      {
        "state": "MI",
        "name": "Milano"
      },
      {
        "state": "MO",
        "name": "Modena"
      },
      {
        "state": "MB",
        "name": "Monza e della Brianza"
      },
      {
        "state": "NA",
        "name": "Napoli"
      },
      {
        "state": "NO",
        "name": "Novara"
      },
      {
        "state": "NU",
        "name": "Nuoro"
      },
      {
        "state": "OG",
        "name": "Ogliastra"
      },
      {
        "state": "OT",
        "name": "Olbia-Tempio"
      },
      {
        "state": "OR",
        "name": "Oristano"
      },
      {
        "state": "PD",
        "name": "Padova"
      },
      {
        "state": "PA",
        "name": "Palermo"
      },
      {
        "state": "PR",
        "name": "Parma"
      },
      {
        "state": "PV",
        "name": "Pavia"
      },
      {
        "state": "PG",
        "name": "Perugia"
      },
      {
        "state": "PU",
        "name": "Pesaro e Urbino"
      },
      {
        "state": "PE",
        "name": "Pescara"
      },
      {
        "state": "PC",
        "name": "Piacenza"
      },
      {
        "state": "PI",
        "name": "Pisa"
      },
      {
        "state": "PT",
        "name": "Pistoia"
      },
      {
        "state": "PN",
        "name": "Pordenone"
      },
      {
        "state": "PZ",
        "name": "Potenza"
      },
      {
        "state": "PO",
        "name": "Prato"
      },
      {
        "state": "RG",
        "name": "Ragusa"
      },
      {
        "state": "RA",
        "name": "Ravenna"
      },
      {
        "state": "RC",
        "name": "Reggio Calabria"
      },
      {
        "state": "RE",
        "name": "Reggio Emilia"
      },
      {
        "state": "RI",
        "name": "Rieti"
      },
      {
        "state": "RN",
        "name": "Rimini"
      },
      {
        "state": "RM",
        "name": "Roma"
      },
      {
        "state": "RO",
        "name": "Rovigo"
      },
      {
        "state": "SA",
        "name": "Salerno"
      },
      {
        "state": "SS",
        "name": "Sassari"
      },
      {
        "state": "SV",
        "name": "Savona"
      },
      {
        "state": "SI",
        "name": "Siena"
      },
      {
        "state": "SR",
        "name": "Siracusa"
      },
      {
        "state": "SO",
        "name": "Sondrio"
      },
      {
        "state": "SU",
        "name": "Sud Sardegna"
      },
      {
        "state": "TA",
        "name": "Taranto"
      },
      {
        "state": "TE",
        "name": "Teramo"
      },
      {
        "state": "TR",
        "name": "Terni"
      },
      {
        "state": "TO",
        "name": "Torino"
      },
      {
        "state": "TP",
        "name": "Trapani"
      },
      {
        "state": "TN",
        "name": "Trento"
      },
      {
        "state": "TV",
        "name": "Treviso"
      },
      {
        "state": "TS",
        "name": "Trieste"
      },
      {
        "state": "UD",
        "name": "Udine"
      },
      {
        "state": "VA",
        "name": "Varese"
      },
      {
        "state": "VE",
        "name": "Venezia"
      },
      {
        "state": "VB",
        "name": "Verbano-Cusio-Ossola"
      },
      {
        "state": "VC",
        "name": "Vercelli"
      },
      {
        "state": "VR",
        "name": "Verona"
      },
      {
        "state": "VV",
        "name": "Vibo Valentia"
      },
      {
        "state": "VI",
        "name": "Vicenza"
      },
      {
        "state": "VT",
        "name": "Viterbo"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "JM",
    "name": "Jamaica",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "JP",
    "name": "Japan",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "23",
        "name": "Aichi"
      },
      {
        "state": "05",
        "name": "Akita"
      },
      {
        "state": "02",
        "name": "Aomori"
      },
      {
        "state": "12",
        "name": "Chiba"
      },
      {
        "state": "38",
        "name": "Ehime"
      },
      {
        "state": "18",
        "name": "Fukui"
      },
      {
        "state": "40",
        "name": "Fukuoka"
      },
      {
        "state": "07",
        "name": "Fukushima"
      },
      {
        "state": "21",
        "name": "Gifu"
      },
      {
        "state": "10",
        "name": "Gunma"
      },
      {
        "state": "34",
        "name": "Hiroshima"
      },
      {
        "state": "01",
        "name": "Hokkaido"
      },
      {
        "state": "28",
        "name": "Hyogo"
      },
      {
        "state": "08",
        "name": "Ibaraki"
      },
      {
        "state": "17",
        "name": "Ishikawa"
      },
      {
        "state": "03",
        "name": "Iwate"
      },
      {
        "state": "37",
        "name": "Kagawa"
      },
      {
        "state": "46",
        "name": "Kagoshima"
      },
      {
        "state": "14",
        "name": "Kanagawa"
      },
      {
        "state": "39",
        "name": "Kochi"
      },
      {
        "state": "43",
        "name": "Kumamoto"
      },
      {
        "state": "26",
        "name": "Kyoto"
      },
      {
        "state": "24",
        "name": "Mie"
      },
      {
        "state": "04",
        "name": "Miyagi"
      },
      {
        "state": "45",
        "name": "Miyazaki"
      },
      {
        "state": "20",
        "name": "Nagano"
      },
      {
        "state": "42",
        "name": "Nagasaki"
      },
      {
        "state": "29",
        "name": "Nara"
      },
      {
        "state": "15",
        "name": "Niigata"
      },
      {
        "state": "44",
        "name": "Oita"
      },
      {
        "state": "33",
        "name": "Okayama"
      },
      {
        "state": "47",
        "name": "Okinawa"
      },
      {
        "state": "27",
        "name": "Osaka"
      },
      {
        "state": "41",
        "name": "Saga"
      },
      {
        "state": "11",
        "name": "Saitama"
      },
      {
        "state": "25",
        "name": "Shiga"
      },
      {
        "state": "32",
        "name": "Shimane"
      },
      {
        "state": "22",
        "name": "Shizuoka"
      },
      {
        "state": "09",
        "name": "Tochigi"
      },
      {
        "state": "36",
        "name": "Tokushima"
      },
      {
        "state": "13",
        "name": "Tokyo"
      },
      {
        "state": "31",
        "name": "Tottori"
      },
      {
        "state": "16",
        "name": "Toyama"
      },
      {
        "state": "30",
        "name": "Wakayama"
      },
      {
        "state": "06",
        "name": "Yamagata"
      },
      {
        "state": "35",
        "name": "Yamaguchi"
      },
      {
        "state": "19",
        "name": "Yamanashi"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "JE",
    "name": "Jersey",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "JO",
    "name": "Jordan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KZ",
    "name": "Kazakstan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KE",
    "name": "Kenya",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KI",
    "name": "Kiribati",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KP",
    "name": "Korea, Democratic People's Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KR",
    "name": "Korea, Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "XK",
    "name": "Kosovo",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KW",
    "name": "Kuwait",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KG",
    "name": "Kyrgyzstan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LA",
    "name": "Lao People's Democratic Republic",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LV",
    "name": "Latvia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LB",
    "name": "Lebanon",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LS",
    "name": "Lesotho",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LR",
    "name": "Liberia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LY",
    "name": "Libyan Arab Jamahiriya",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LI",
    "name": "Liechtenstein",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LT",
    "name": "Lithuania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LU",
    "name": "Luxembourg",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MO",
    "name": "Macau",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MG",
    "name": "Madagascar",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MW",
    "name": "Malawi",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MY",
    "name": "Malaysia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MV",
    "name": "Maldives",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ML",
    "name": "Mali",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MT",
    "name": "Malta",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MH",
    "name": "Marshall Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MQ",
    "name": "Martinique",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MR",
    "name": "Mauritania",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MU",
    "name": "Mauritius",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "YT",
    "name": "Mayotte",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MX",
    "name": "Mexico",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AGU",
        "name": "Aguascalientes"
      },
      {
        "state": "BCN",
        "name": "Baja California"
      },
      {
        "state": "BCS",
        "name": "Baja California Sur"
      },
      {
        "state": "CAM",
        "name": "Campeche"
      },
      {
        "state": "CHP",
        "name": "Chiapas"
      },
      {
        "state": "CHH",
        "name": "Chihuahua"
      },
      {
        "state": "CMX",
        "name": "Ciudad de México"
      },
      {
        "state": "COA",
        "name": "Coahuila"
      },
      {
        "state": "COL",
        "name": "Colima"
      },
      {
        "state": "DIF",
        "name": "Distrito Federal"
      },
      {
        "state": "DUR",
        "name": "Durango"
      },
      {
        "state": "GUA",
        "name": "Guanajuato"
      },
      {
        "state": "GRO",
        "name": "Guerrero"
      },
      {
        "state": "HID",
        "name": "Hidalgo"
      },
      {
        "state": "JAL",
        "name": "Jalisco"
      },
      {
        "state": "MEX",
        "name": "México"
      },
      {
        "state": "MIC",
        "name": "Michoacán"
      },
      {
        "state": "MOR",
        "name": "Morelos"
      },
      {
        "state": "NAY",
        "name": "Nayarit"
      },
      {
        "state": "NLE",
        "name": "Nuevo León"
      },
      {
        "state": "OAX",
        "name": "Oaxaca"
      },
      {
        "state": "PUE",
        "name": "Puebla"
      },
      {
        "state": "QUE",
        "name": "Querétaro"
      },
      {
        "state": "ROO",
        "name": "Quintana Roo"
      },
      {
        "state": "SLP",
        "name": "San Luis Potosí"
      },
      {
        "state": "SIN",
        "name": "Sinaloa"
      },
      {
        "state": "SON",
        "name": "Sonora"
      },
      {
        "state": "TAB",
        "name": "Tabasco"
      },
      {
        "state": "TAM",
        "name": "Tamaulipas"
      },
      {
        "state": "TLA",
        "name": "Tlaxcala"
      },
      {
        "state": "VER",
        "name": "Veracruz"
      },
      {
        "state": "YUC",
        "name": "Yucatán"
      },
      {
        "state": "ZAC",
        "name": "Zacatecas"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "FM",
    "name": "Micronesia, Federated States of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MD",
    "name": "Moldova, Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MC",
    "name": "Monaco",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MN",
    "name": "Mongolia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ME",
    "name": "Montenegro",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MS",
    "name": "Montserrat",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MA",
    "name": "Morocco",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MZ",
    "name": "Mozambique",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MM",
    "name": "Myanmar",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NA",
    "name": "Namibia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NR",
    "name": "Nauru",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NP",
    "name": "Nepal",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NL",
    "name": "Netherlands",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AN",
    "name": "Netherlands Antilles",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NC",
    "name": "New Caledonia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NZ",
    "name": "New Zealand",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NI",
    "name": "Nicaragua",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NE",
    "name": "Niger",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NG",
    "name": "Nigeria",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NU",
    "name": "Niue",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NF",
    "name": "Norfolk Island",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MK",
    "name": "North Macedonia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "MP",
    "name": "Northern Mariana Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "NO",
    "name": "Norway",
    "eu": false,
    "language": "no",
    "currency": "NOK",
    "pricelist": "25",
    "market": "1"
  },
  {
    "country": "OM",
    "name": "Oman",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PK",
    "name": "Pakistan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PW",
    "name": "Palau",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PS",
    "name": "Palestine, State of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PA",
    "name": "Panama",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PG",
    "name": "Papua New Guinea",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PY",
    "name": "Paraguay",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PE",
    "name": "Peru",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PH",
    "name": "Philippines",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PL",
    "name": "Poland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PT",
    "name": "Portugal",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PR",
    "name": "Puerto Rico",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "QA",
    "name": "Qatar",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RE",
    "name": "Reunion",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RO",
    "name": "Romania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RU",
    "name": "Russian Federation",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RW",
    "name": "Rwanda",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "KN",
    "name": "Saint Kitts and Nevis",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LC",
    "name": "Saint Lucia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "PM",
    "name": "Saint Pierre and Miquelon",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VC",
    "name": "Saint Vincent and the Grenadines",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "WS",
    "name": "Samoa",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SM",
    "name": "San Marino",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ST",
    "name": "Sao Tome and Principe",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SA",
    "name": "Saudi Arabia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SN",
    "name": "Senegal",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "RS",
    "name": "Serbia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SC",
    "name": "Seychelles",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SL",
    "name": "Sierra Leone",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SG",
    "name": "Singapore",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SX",
    "name": "Sint Maarten (Dutch part)",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SK",
    "name": "Slovakia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SI",
    "name": "Slovenia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SB",
    "name": "Solomon Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SO",
    "name": "Somalia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ZA",
    "name": "South Africa",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ES",
    "name": "Spain",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "LK",
    "name": "Sri Lanka",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SD",
    "name": "Sudan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SR",
    "name": "Suriname",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SJ",
    "name": "Svalbard",
    "eu": false,
    "language": "en",
    "currency": "NOK",
    "pricelist": "25",
    "market": "1"
  },
  {
    "country": "SE",
    "name": "Sweden",
    "eu": true,
    "language": "en",
    "currency": "SEK",
    "pricelist": "32",
    "market": "13"
  },
  {
    "country": "CH",
    "name": "Switzerland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "SY",
    "name": "Syrian Arab Republic",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TW",
    "name": "Taiwan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TJ",
    "name": "Tajikistan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TZ",
    "name": "Tanzania, United Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TH",
    "name": "Thailand",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TG",
    "name": "Togo",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TK",
    "name": "Tokelau",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TO",
    "name": "Tonga",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TT",
    "name": "Trinidad and Tobago",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TN",
    "name": "Tunisia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TM",
    "name": "Turkmenistan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TC",
    "name": "Turks and Caicos Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TV",
    "name": "Tuvalu",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "TR",
    "name": "Türkiye",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "UG",
    "name": "Uganda",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "UA",
    "name": "Ukraine",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "AE",
    "name": "United Arab Emirates",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "GB",
    "name": "United Kingdom",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "GB-ENG",
        "name": "England"
      },
      {
        "state": "GB-NIR",
        "name": "Northern Ireland"
      },
      {
        "state": "GB-SCT",
        "name": "Scotland"
      },
      {
        "state": "GB-WLS",
        "name": "Wales"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "US",
    "name": "United States",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AL",
        "name": "Alabama"
      },
      {
        "state": "AK",
        "name": "Alaska"
      },
      {
        "state": "AS",
        "name": "American Samoa"
      },
      {
        "state": "AZ",
        "name": "Arizona"
      },
      {
        "state": "AR",
        "name": "Arkansas"
      },
      {
        "state": "AA",
        "name": "Armed Forces Americas"
      },
      {
        "state": "AE",
        "name": "Armed Forces Europe"
      },
      {
        "state": "AP",
        "name": "Armed Forces Pacific"
      },
      {
        "state": "CA",
        "name": "California"
      },
      {
        "state": "CO",
        "name": "Colorado"
      },
      {
        "state": "CT",
        "name": "Connecticut"
      },
      {
        "state": "DE",
        "name": "Delaware"
      },
      {
        "state": "DC",
        "name": "District of Columbia"
      },
      {
        "state": "FM",
        "name": "Federated States of Micronesia"
      },
      {
        "state": "FL",
        "name": "Florida"
      },
      {
        "state": "GA",
        "name": "Georgia"
      },
      {
        "state": "GU",
        "name": "Guam"
      },
      {
        "state": "HI",
        "name": "Hawaii"
      },
      {
        "state": "ID",
        "name": "Idaho"
      },
      {
        "state": "IL",
        "name": "Illinois"
      },
      {
        "state": "IN",
        "name": "Indiana"
      },
      {
        "state": "IA",
        "name": "Iowa"
      },
      {
        "state": "KS",
        "name": "Kansas"
      },
      {
        "state": "KY",
        "name": "Kentucky"
      },
      {
        "state": "LA",
        "name": "Louisiana"
      },
      {
        "state": "ME",
        "name": "Maine"
      },
      {
        "state": "MH",
        "name": "Marshall Islands"
      },
      {
        "state": "MD",
        "name": "Maryland"
      },
      {
        "state": "MA",
        "name": "Massachusetts"
      },
      {
        "state": "MI",
        "name": "Michigan"
      },
      {
        "state": "MN",
        "name": "Minnesota"
      },
      {
        "state": "MS",
        "name": "Mississippi"
      },
      {
        "state": "MO",
        "name": "Missouri"
      },
      {
        "state": "MT",
        "name": "Montana"
      },
      {
        "state": "NE",
        "name": "Nebraska"
      },
      {
        "state": "NV",
        "name": "Nevada"
      },
      {
        "state": "NH",
        "name": "New Hampshire"
      },
      {
        "state": "NJ",
        "name": "New Jersey"
      },
      {
        "state": "NM",
        "name": "New Mexico"
      },
      {
        "state": "NY",
        "name": "New York"
      },
      {
        "state": "NC",
        "name": "North Carolina"
      },
      {
        "state": "ND",
        "name": "North Dakota"
      },
      {
        "state": "MP",
        "name": "Northern Mariana Islands"
      },
      {
        "state": "OH",
        "name": "Ohio"
      },
      {
        "state": "OK",
        "name": "Oklahoma"
      },
      {
        "state": "OR",
        "name": "Oregon"
      },
      {
        "state": "PW",
        "name": "Palau"
      },
      {
        "state": "PA",
        "name": "Pennsylvania"
      },
      {
        "state": "PR",
        "name": "Puerto Rico"
      },
      {
        "state": "RI",
        "name": "Rhode Island"
      },
      {
        "state": "SC",
        "name": "South Carolina"
      },
      {
        "state": "SD",
        "name": "South Dakota"
      },
      {
        "state": "TN",
        "name": "Tennessee"
      },
      {
        "state": "TX",
        "name": "Texas"
      },
      {
        "state": "UT",
        "name": "Utah"
      },
      {
        "state": "VT",
        "name": "Vermont"
      },
      {
        "state": "VI",
        "name": "Virgin Islands"
      },
      {
        "state": "VA",
        "name": "Virginia"
      },
      {
        "state": "WA",
        "name": "Washington"
      },
      {
        "state": "WV",
        "name": "West Virginia"
      },
      {
        "state": "WI",
        "name": "Wisconsin"
      },
      {
        "state": "WY",
        "name": "Wyoming"
      }
    ],
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "UM",
    "name": "United States Minor Outlying Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "UY",
    "name": "Uruguay",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "UZ",
    "name": "Uzbekistan",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VU",
    "name": "Vanuatu",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VE",
    "name": "Venezuela",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VN",
    "name": "Vietnam",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VG",
    "name": "Virgin Islands, British",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "VI",
    "name": "Virgin Islands, U.S.",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "WF",
    "name": "Wallis and Futuna",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "YE",
    "name": "Yemen",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ZM",
    "name": "Zambia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  },
  {
    "country": "ZW",
    "name": "Zimbabwe",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "26",
    "market": "3"
  }
];